import client from './main-client';

export const addBrokerCompanyApi = (data) => client().post('/broker-company', data);
export const getBrokerCompanyApi = ({ id, ...params }) => client().get(`/broker-company/${id}`, { params });
export const getBrokerCompaniesApi = (params) => client().get('/broker-company', { params });
export const updateBrokerCompanyApi = ({ id, ...params }) => client().patch(`/broker-company/${id}`, { params });
